import React, { Fragment } from "react";
import { lib } from "react-single-app";
import {
    Button,
    message,
    Space,
    Modal,
    Form,
    Input,
    Card,
    Table,
    Steps,
    InputNumber,
    Select,
} from "antd";
import FormList from "../../components/form-list.js";
import moment from "moment";
const { TextArea } = Input;
const FormItem = Form.Item;
const { Step } = Steps;
const { Option } = Select;

export default class Page extends React.Component {
    constructor(props) {
        super();
        this.state = {
            tallyReportDetailList: [],
            searchList: [],
            showGoodsModalVisible: false,
            detail: {},
            expandedRowKeys: [],
            baseInfoText: [
                {
                    type: "TEXT",
                    labelName: "理货编号",
                    labelKey: "tallyOrderNo",
                },
                {
                    type: "TEXT",
                    labelName: "理货类型",
                    labelKey: "tallyTypeName",
                },
                {
                    type: "TEXT",
                    labelName: "到货时间",
                    labelKey: "warehouseTime",
                    render: detail => {
                        return detail.warehouseTime
                            ? new Date(detail.warehouseTime).format("yyyy-MM-dd hh:mm:ss")
                            : "";
                    },
                },
                {
                    type: "TEXT",
                    labelName: "用户名称",
                    labelKey: "userName",
                },
                {
                    type: "TEXT",
                    labelName: "理货仓库（云仓）",
                    labelKey: "logicWarehouseName",
                },
                {
                    type: "TEXT",
                    labelName: "理货人员",
                    labelKey: "tallyPersonnel",
                },
                {
                    type: "TEXT",
                    labelName: "模拟回传",
                    labelKey: "mockTypeName",
                },
                {
                    type: "TEXT",
                    labelName: "账册号",
                    labelKey: "accountCode",
                },
                {
                    type: "TEXT",
                    labelName: "电商名称",
                    labelKey: "companyName",
                },
                {
                    type: "TEXT",
                    labelName: "托数",
                    labelKey: "torr",
                },
            ],
        };
        this.formRef = React.createRef();
    }

    componentDidMount() {
        lib.getParam("tallyOrderNo") && this.fetchDetail();
    }

    fetchDetail() {
        lib.request({
            url: "/ares-web/tallyReport/detail",
            data: {
                tallyOrderNo: lib.getParam("tallyOrderNo"),
            },
            needMask: true,
            success: detail => {
                let tallyReportDetailList = detail.tallyReportDetailList,
                    totaltallyUnitPrice = 0,
                    totaltallyAmount = 0;
                tallyReportDetailList.forEach(({ tallyUnitPrice, tallyAmount }) => {
                    totaltallyUnitPrice += tallyUnitPrice;
                    totaltallyAmount += tallyAmount;
                });
                let { baseInfoText } = this.state;
                if (detail?.tallyType === "CG_RK" && baseInfoText.length === 4) {
                    baseInfoText.push({
                        type: "TEXT",
                        labelName: "供应商",
                        labelKey: "supplierName",
                    });
                } else if (detail?.tallyType === "XS_CK" && baseInfoText.length === 4) {
                    baseInfoText.push({
                        type: "TEXT",
                        labelName: "经销商",
                        labelKey: "customerName",
                    });
                }
                this.setState({
                    detail,
                    tallyReportDetailList,
                    totaltallyUnitPrice,
                    totaltallyAmount,
                    baseInfoText,
                });
            },
        });
    }

    parseNum(num) {
        if (!num) return 0;
        return parseFloat(num.toFixed(2));
    }

    tableSummary() {
        let {
            detail: { qualityNum, planNum, defectiveNum, tallyNum },
            totaltallyUnitPrice,
            totaltallyAmount,
        } = this.state;
        return (
            <>
                <Table.Summary.Row>
                    <Table.Summary.Cell>总计</Table.Summary.Cell>
                    <Table.Summary.Cell colSpan={4}></Table.Summary.Cell>
                    <Table.Summary.Cell>{planNum}</Table.Summary.Cell>
                    <Table.Summary.Cell>{tallyNum}</Table.Summary.Cell>
                </Table.Summary.Row>
            </>
        );
    }

    expandedRowRender(record) {
        let columns = [
            {
                title: "批次号",
                dataIndex: "batchCode",
            },
            {
                title: "批次ID",
                dataIndex: "internalBatchCode",
            },
            {
                title: "生产日期",
                dataIndex: "productionDate",
                render: text => (text ? moment(text).format("YYYY-MM-DD") : ""),
            },
            {
                title: "失效日期",
                dataIndex: "expireDate",
                render: text => (text ? moment(text).format("YYYY-MM-DD") : ""),
            },
            {
                title: "库存类型",
                width: 160,
                dataIndex: "inventoryType",
                render: text => {
                    let obj = {
                        QUALITY: "正品",
                        DEFECTIVE: "次品",
                        QUALITY_INVALID: "异常正品",
                        DEFECTIVE_INVALID: "异常次品",
                    };
                    return obj[text];
                },
            },
            {
                title: "实际理货数量",
                dataIndex: "tallyNum",
            },
            {
                title: "备注",
                dataIndex: "remark",
            },
        ];
        return (
            <Table
                dataSource={record.detailBatchLists}
                columns={columns}
                pagination={false}
                rowKey="id"
            />
        );
    }

    rowExpandable(record) {
        return Boolean(record.detailBatchLists?.length);
    }

    onExpand(expanded, record) {
        if (expanded) {
            this.setState({
                expandedRowKeys: this.state.expandedRowKeys.concat([record.id]),
            });
        } else {
            this.setState({
                expandedRowKeys: this.state.expandedRowKeys.filter(item => item !== record.id),
            });
        }
    }

    render() {
        const { detail, tallyReportDetailList, baseInfoText, expandedRowKeys } = this.state;
        let columns = [
            {
                title: "序号",
                dataIndex: "",
                width: 100,
                render: (text, row, index) => {
                    return index;
                },
            },
            {
                title: "货品名称",
                dataIndex: "goodsName",
                width: 190,
            },
            {
                title: "料号",
                dataIndex: "materialCode",
                width: 80,
            },
            {
                title: "SKU",
                dataIndex: "sku",
                width: 80,
            },
            {
                title: "条形码",
                dataIndex: "barcode",
                width: 160,
            },
            {
                title: "计划理货数量",
                dataIndex: "planNum",
                width: 130,
            },
            {
                title: "实际理货数量",
                dataIndex: "tallyNum",
                width: 120,
            },
            {
                title: "合格品",
                dataIndex: "qualifiedNum",
                width: 130,
            },
            {
                title: "残次品",
                dataIndex: "damagedNum",
                width: 120,
            },
            {
                title: "是否多货少货",
                width: 120,
                render: (text, record) => {
                    if (record.planNum > record.tallyNum) {
                        return "少货";
                    } else if (record.planNum < record.tallyNum) {
                        return "多货";
                    } else {
                        return "";
                    }
                },
            },
            {
                title: "差异数量",
                dataIndex: "differencesNum",
                width: 120,
            },
            {
                title: "是否多品",
                dataIndex: "multiTypeName",
                width: 120,
            },
            // {
            //     title: "实际托数",
            //     dataIndex: "torr",
            //     width: 120
            // },
            {
                title: "备注",
                dataIndex: "remark",
                width: 120,
            },
        ];
        let current = 0,
            text = "审核完成",
            status = "";
        switch (detail?.approvalStatus) {
            case "SP_DRAFT":
                current = 1;
                break;
            case "SP_IS":
                current = 2;
                break;
            case "SP_SUCCESS":
                current = 3;
                text = "审核成功";
                status = "finish";
                break;
            case "SP_FAIL":
                current = 3;
                text = "审核驳回";
                status = "error";
                break;
            case "SP_FINISH":
                current = 3;
                text = "审核成功";
                status = "finish";
                break;
            default:
                current = 1;
        }
        return (
            <div className="body" style={{ height: "100%" }}>
                <Card bordered={false}>
                    <Steps
                        style={{ width: "75%", float: "left" }}
                        current={current}
                        status={status}>
                        <Step
                            title="已创建"
                            description={
                                detail?.createTime
                                    ? moment(detail?.createTime).format("YYYY-MM-DD HH:mm:ss")
                                    : ""
                            }
                        />
                        <Step title="待审核" description="" />
                        <Step title="审核中" description="" />
                        <Step
                            title={text}
                            description={current === 3 ? detail?.operatorRemark : ""}
                        />
                    </Steps>
                </Card>

                {/* form表单 */}
                <Form initialValues={detail} ref={this.formRef}>
                    <Card bordered={false} title="基本信息">
                        {
                            <FormList
                                configList={baseInfoText}
                                detail={detail}
                                form={this.formRef.current}
                            />
                        }
                    </Card>
                </Form>
                <Card bordered={false} title="货品信息">
                    <Table
                        columns={columns}
                        dataSource={tallyReportDetailList}
                        pagination={false}
                        summary={() => this.tableSummary()}
                        scroll={{ x: "max-content" }}
                        rowKey="id"
                        expandable={{
                            expandedRowRender: this.expandedRowRender.bind(this),
                            rowExpandable: this.rowExpandable.bind(this),
                            expandedRowKeys: expandedRowKeys,
                            onExpand: this.onExpand.bind(this),
                        }}
                    />
                </Card>
                {/* 附件 */}
                <Card bordered={false} title="相关文件">
                    {
                        <div className="upload-div">
                            附件：
                            <a href={detail?.attachmentFile?.[0]?.key}>
                                {" "}
                                {detail?.attachmentFile && "下载附件"}
                            </a>
                        </div>
                    }
                    <FormItem label="备注">{detail?.remark}</FormItem>
                </Card>
            </div>
        );
    }
}
